/**
 * A conversation-correlation id — not a security token, so we avoid relying
 * on crypto.randomUUID() (inconsistently available across the ad-creative
 * host environments this SDK runs in) in favor of a plain, dependency-free
 * generator.
 */
export function generateSessionId(): string {
  const random = Math.random().toString(36).slice(2, 10);
  return `sess_${Date.now().toString(36)}_${random}`;
}
